import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { ApiError } from "@/lib/apiError";

type VerifyEmailInput = { token: string };
type VerifyEmailResponse = {
  tenant_slug: string;
};

export function useVerifyEmail() {
  return useMutation<VerifyEmailResponse, ApiError, VerifyEmailInput>({
    mutationFn: async ({ token }) => {
      const resp = await apiClient.post<VerifyEmailResponse>("/auth/verify", { token });
      return resp.data;
    },
  });
}
